<div class="buyer-group-parent-detail">
    <page-header
        i18n-titleText
        titleText="Invoice Group"
        [backButtonText]="backButtonText$ | async"
        (handleBackButtonClick)="navigateBack()"
    >
    </page-header>
    <div class="page-container container-fluid">
        <div *ngIf="isLoading">
            <lsq-circle-loader></lsq-circle-loader>
        </div>

        <div class="row" *ngIf="!isLoading">
            <div class="summary-table-card-wrapper col-12">
                <card
                    i18n-headerTitle
                    headerTitle="Invoice Group Summary"
                    id="invoices-table-card"
                    *ngIf="!(responsiveService.mdBelow | async)"
                >
                    <div card-body class="invoice-table">
                        <lsq-data-table
                            *ngIf="summaryDataSource"
                            [hasHeader]="true"
                            [dataSource]="summaryDataSource"
                            [isPaginated]="false"
                            [layoutFixed]="true"
                            [columnVisibilities]="{
                                paymentDate: showPaymentdata$ | async
                            }"
                        >
                            <lsq-column
                                [column]="{
                                    header: statusI18n,
                                    key: 'invoiceStatus',
                                    width: '15%',
                                    sortable: false
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <status-pill
                                        [status]="
                                            row.invoiceStatus ? row.invoiceStatus : ineligibleStatus
                                        "
                                        [color]="
                                            statusColor[
                                                row.invoiceStatus
                                                    ? row.invoiceStatus
                                                    : ineligibleStatus
                                            ]
                                        "
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                    >
                                    </status-pill>
                                </ng-template>
                            </lsq-column>

                            <lsq-currency-column
                                [column]="{
                                    header: creditAmountI18n,
                                    key: 'credits',
                                    width: '30%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>

                            <lsq-currency-column
                                [column]="{
                                    header: positiveInvoicesI18n,
                                    key: 'totalInvoiceAmount',
                                    width: '25%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>
                            <lsq-spacer-column [width]="'3%'"></lsq-spacer-column>
                            <lsq-date-column
                                [isShortDate]="true"
                                [alignRight]="true"
                                [column]="{
                                    header: paymentDateI18n,
                                    key: 'paymentDate',
                                    width: '12rem',
                                    sortable: false
                                }"
                            >
                            </lsq-date-column>
                            <lsq-currency-column
                                [column]="{
                                    header: paymentTotalI18n,
                                    key: 'total',
                                    width: '30%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>
                        </lsq-data-table>
                    </div>
                </card>

                <div *ngIf="responsiveService.mdBelow | async">
                    <h2 class="mobile-section-header" i18n>Invoice Group Summary</h2>
                    <lsq-data-table-mobile [dataSource]="summaryDataSource" [isPaginated]="false">
                        <ng-template #mobileCardHeader let-row="row">
                            <div class="mtc-header-content">
                                <div class="invoice-list-mobile-card-header">
                                    <div class="mtc-header-content-left">
                                        <div class="mtc-header-title">
                                            {{ row.total | currencyDash }}
                                        </div>
                                    </div>
                                    <div class="mtc-header-content-right">
                                        <status-pill
                                            [status]="
                                                invoiceGroup?.invoiceStatus || ineligibleStatus
                                            "
                                            [color]="
                                                statusColor[
                                                    invoiceGroup?.invoiceStatus || ineligibleStatus
                                                ]
                                            "
                                            [displayValueMap]="invoiceFundingStatusDisplay"
                                        >
                                        </status-pill>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #mobileCardColumns let-row="row">
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ positiveInvoicesI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ invoiceGroup.totalInvoiceAmount | currencyDash }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ creditAmountI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ invoiceGroup.credits | currencyDash }}
                                </div>
                            </div>

                            <div class="card-item" *ngIf="invoiceGroup.paymentDate">
                                <div class="card-item-label">
                                    {{ paymentDateI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ invoiceGroup.paymentDate | lsqDate: 'shortDate' }}
                                </div>
                            </div>
                        </ng-template>
                    </lsq-data-table-mobile>
                </div>
            </div>

            <div class="included-invoices-table-card-wrapper col-12">
                <card
                    i18n-headerTitle
                    headerTitle="Included Invoices"
                    id="invoices-table-card"
                    *ngIf="!(responsiveService.mdBelow | async)"
                >
                    <div card-body class="invoice-table">
                        <lsq-data-table
                            *ngIf="dataSource"
                            [hasHeader]="true"
                            [dataSource]="dataSource"
                            [isPaginated]="false"
                            [layoutFixed]="true"
                            [columnVisibilities]="{
                                revoke:
                                    !(
                                        invoiceGroup.invoiceStatus ===
                                        invoiceFundingStatus.EARLY_PAID
                                    ) &&
                                    !(
                                        invoiceGroup.invoiceStatus ===
                                        invoiceFundingStatus.EARLY_PAID_CLOSED
                                    ) &&
                                    !(
                                        invoiceGroup.invoiceStatus === invoiceFundingStatus.REVOKED
                                    ) &&
                                    !(invoiceGroup.invoiceStatus === invoiceFundingStatus.CLOSED) &&
                                    (canRevokeFeatureFlag$ | async) &&
                                    (buyerAccountSharedService.canRevokeInvoices$ | async)
                            }"
                        >
                            <lsq-row-count-column></lsq-row-count-column>

                            <lsq-column
                                [column]="{
                                    header: supplierI18n,
                                    key: 'sellerName',
                                    width: '23%',
                                    sortable: false
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <lsq-smart-truncate [value]="invoiceGroup.sellerName || ''">
                                    </lsq-smart-truncate>
                                </ng-template>
                            </lsq-column>
                            <lsq-column
                                [column]="{
                                    header: invoiceNumberI18n,
                                    key: 'invoiceNumber',
                                    width: '22%',
                                    sortable: false,
                                    truncateAfter: invoiceNumberTruncateAfter$ | async,
                                    reverseTruncate: true,
                                    onCellClick: openInvoiceDetailsBound
                                }"
                            >
                            </lsq-column>
                            <lsq-date-column
                                [isShortDate]="true"
                                [column]="{
                                    header: invoiceDateI18n,
                                    key: 'invoiceDate',
                                    width: '11rem',
                                    sortable: false
                                }"
                            >
                            </lsq-date-column>
                            <lsq-date-column
                                [isShortDate]="true"
                                [column]="{
                                    header: invoiceDueDateI18n,
                                    key: 'dueDate',
                                    width: '11rem',
                                    sortable: false
                                }"
                            >
                            </lsq-date-column>

                            <lsq-currency-column
                                [column]="{
                                    header: invoiceAmountI18n,
                                    key: 'amount',
                                    width: '15%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>
                            <lsq-spacer-column [width]="'3%'"></lsq-spacer-column>
                            <lsq-column
                                [column]="{
                                    header: invoiceStatusI18n,
                                    key: 'status',
                                    width: '11rem',
                                    sortable: true
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <status-pill
                                        [status]="transformStatusBound(row)"
                                        [color]="statusColor[transformStatusBound(row)]"
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                    >
                                    </status-pill>
                                </ng-template>
                            </lsq-column>
                            <lsq-button-column
                                [column]="{
                                    header: revokeHeaderI18n,
                                    key: 'revoke',
                                    width: '7rem'
                                }"
                                (buttonClick)="handleRevokeClick($event)"
                                [hideButton]="revokeButtonIsHiddenBound"
                                [disableButton]="revokeButtonIsDisabledBound"
                                [icon]="icons.CloseSmall"
                            >
                            </lsq-button-column>
                        </lsq-data-table>
                    </div>
                </card>

                <div *ngIf="responsiveService.mdBelow | async">
                    <h2 class="mobile-section-header" i18n>Included Invoices</h2>
                    <lsq-data-table-mobile [dataSource]="dataSource" [isPaginated]="false">
                        <ng-template #mobileCardHeader let-row="row">
                            <div class="mtc-header-content">
                                <div class="invoice-list-mobile-card-header">
                                    <div class="mtc-header-content-left">
                                        <div class="mtc-header-title">
                                            {{ row.invoiceNumber }}
                                        </div>
                                    </div>
                                    <div class="mtc-header-content-right">
                                        <status-pill
                                            [status]="transformStatusBound(row)"
                                            [color]="statusColor[transformStatusBound(row)]"
                                            [displayValueMap]="invoiceFundingStatusDisplay"
                                        >
                                        </status-pill>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #mobileCardColumns let-row="row">
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ supplierI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ invoiceGroup.sellerName }}
                                </div>
                            </div>
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ invoiceDateI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.invoiceDate | lsqDate: 'shortDate' }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ invoiceDueDateI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.dueDate | lsqDate: 'shortDate' }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ invoiceAmountI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.amount | currencyDash }}
                                </div>
                            </div>
                        </ng-template>
                    </lsq-data-table-mobile>
                </div>
            </div>
        </div>
    </div>
</div>
